import { tap } from 'lodash/fp';
import config from '../helpers/config';
import loading from './loading';
import loaded from './loaded';
import { sendAddToCartEvent } from '../analytics/addToCartAnalytics';
import globalError from './globalError';
import CartEstimateContext from '../helpers/cartEstimateContext';
import { getItemsForEstimate } from '../selectors/getItemsForEstimate';
import { sites } from '../helpers/globalVariables';

function collectItemsForEstimate(designId, entities) {
  const { estimates, containers, items } = entities;

  const selectedEstimate = estimates.byId[designId];
  const containersForSelectedEstimate = selectedEstimate.containers
    .map(containerId => containers.byId[containerId]);
  const itemsForEstimate = containersForSelectedEstimate
    .map(container => container.items)
    .reduce((a, b) => a.concat(b), [])
    .map(itemId => items.byId[itemId]);

  return itemsForEstimate.filter(item => item.itemProduct);
}

export default (itemsForAnalytics = null, designIdToSave = null) => (dispatch, getState) => {
  dispatch(loading());
  const { entities, uiState } = getState().estimateBuilder;

  const designId = designIdToSave || uiState.selectedEstimate;
  const context = new CartEstimateContext();

  const itemsWithoutProducts = getItemsForEstimate(entities, designId).reduce(
    (acc, item) => (item.itemProduct ? acc : acc + 1),
    0,
  );

  if (itemsWithoutProducts > 0) {
    dispatch(globalError({ text: 'All windows must have an item selected.' }));
  } else {
    context.cartAnEstimate(designId)
      .then(() => {
        if (itemsForAnalytics === null) {
          const selectedItems = collectItemsForEstimate(designId, entities);
          sendAddToCartEvent(selectedItems);
        } else {
          sendAddToCartEvent(itemsForAnalytics);
        }
        window.location = window.globalConfig.siteId === sites.theHomeDepot
          ? config.externalCartUrl
          : config.cartUrl;
      })
      .then(tap(() => dispatch(loaded)))
      .catch((err) => {
        console.error(`Carting an estimate failed. Error Message: ${err.message}`);
        return dispatch(globalError({ err }));
      });
  }
};
